import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useLocalizedDateStrings = () => {
  const { t } = useTranslation();

  const localized = useMemo(
    () => ({
      shortDays: [
        t('sunday_short', { defaultValue: 'S' }),
        t('monday_short', { defaultValue: 'M' }),
        t('tuesday_short', { defaultValue: 'D' }),
        t('wednesday_short', { defaultValue: 'M' }),
        t('thursday_short', { defaultValue: 'D' }),
        t('friday_short', { defaultValue: 'F' }),
        t('saturday_short', { defaultValue: 'S' }),
      ],
      days: [
        t('sunday', { defaultValue: 'Sonntag' }),
        t('monday', { defaultValue: 'Montag' }),
        t('tuesday', { defaultValue: 'Dienstag' }),
        t('wednesday', { defaultValue: 'Mittwoch' }),
        t('thursday', { defaultValue: 'Donnerstag' }),
        t('friday', { defaultValue: 'Freitag' }),
        t('saturday', { defaultValue: 'Samstag' }),
      ],
      months: [
        t('january', { defaultValue: 'Januar' }),
        t('february', { defaultValue: 'Februar' }),
        t('march', { defaultValue: 'März' }),
        t('april', { defaultValue: 'April' }),
        t('may', { defaultValue: 'Mai' }),
        t('june', { defaultValue: 'Juni' }),
        t('july', { defaultValue: 'Juli' }),
        t('august', { defaultValue: 'August' }),
        t('september', { defaultValue: 'September' }),
        t('october', { defaultValue: 'Oktober' }),
        t('november', { defaultValue: 'November' }),
        t('december', { defaultValue: 'Dezember' }),
      ],
    }),
    [t],
  );

  return localized;
};
